import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useSiteData } from '../../context/DataContext';
import { motion } from 'framer-motion';
import { FiChevronLeft } from 'react-icons/fi';
import './Category.css';
import ProductCard from '../ProductCard/ProductCard';

function Category() {
  const { categoryId } = useParams();
  const { getCategoryById, getProductsByCategory } = useSiteData();
  const category = getCategoryById(categoryId);
  const products = getProductsByCategory(categoryId);
  const topRef = useRef(null);

  // Scroll to top when component mounts
  useEffect(() => {
    const scrollToTop = () => {
      if (topRef.current) {
        topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    scrollToTop();
    setTimeout(scrollToTop, 100);
  }, [categoryId]);

  if (!category) {
    return <div className="category-not-found">Category not found</div>;
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <div className="category-page-container">
      <div ref={topRef}></div>

      {/* Premium Back Button */}
      <motion.button
        className="back-home-btn"
        onClick={() => window.location.href = '/'}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        whileHover={{ x: -5 }}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          color: 'rgba(255, 255, 255, 0.6)',
          padding: '10px 20px',
          borderRadius: '100px',
          cursor: 'pointer',
          marginBottom: '40px',
          fontFamily: 'var(--font-nav)',
          fontSize: '11px',
          textTransform: 'uppercase',
          letterSpacing: '2px',
          transition: 'all 0.3s ease',
          backdropFilter: 'blur(10px)'
        }}
      >
        <FiChevronLeft /> Back to Gallery
      </motion.button>

      <div className="category-header">
        <h1 className="category-title creative-font">{category.name}</h1>
        <p className="category-description">{category.description}</p>
      </div>
      <motion.div
        className="posters-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)', // Updated for 4 columns on desktop
          gap: '40px', // Updated gap
          margin: '0 auto',
          padding: '0 30px'
        }}
      >
        {products.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </motion.div>
      <style>{`
        @media (max-width: 1400px) {
            .posters-grid {
                grid-template-columns: repeat(3, 1fr) !important;
            }
        }
        @media (max-width: 1024px) {
            .posters-grid {
                grid-template-columns: repeat(2, 1fr) !important;
                gap: 30px !important;
            }
        }
        @media (max-width: 768px) {
            .posters-grid {
                grid-template-columns: repeat(2, 1fr) !important;
                gap: 8px !important;
                padding: 0 5px !important;
            }
            .back-home-btn {
                padding: 8px 15px !important;
                font-size: 10px !important;
            }
        }
      `}</style>
    </div>
  );
}

export default Category;
